import React, { useEffect } from "react"
import { Button, useSystemMessage } from "@gorilla-technologies/customer-ui"
import { useWallet } from "../providers"

// Checks if a certain query param is set
const hasQueryParam = param =>
  new URLSearchParams(window.location.search).has(param)

// Removes all query params from the current URL
const resetQueryParams = () => {
  const newUrl = window.location.href.split("?")[0]
  window.history.pushState({ path: newUrl }, "", newUrl)
}

export const Wallet = () => {
  const { wallet, isLoading } = useWallet()
  const isConnected = wallet?.isConnected()
  const openSystemMessage = useSystemMessage()

  useEffect(() => {
    if (isLoading) return

    // The Mintbase wallet doesn't give us a callback after a successful login or logut
    // To still be able to show a success/error message we append a query parameter
    // before the login/logout. After the login/logout when the page reloads we check
    // for this parameter and determine if we want to show a message to the user
    // Show login message
    const justLoggedIn = hasQueryParam("login")
    if (justLoggedIn) {
      if (isConnected) {
        openSystemMessage({
          text: "You are now logged in with your wallet",
          kind: "success",
        })
      } else {
        openSystemMessage({
          text: "Login unsuccessful",
          kind: "error",
        })
      }

      resetQueryParams()
    }

    // Show logout message
    const justLoggedOut = hasQueryParam("logout")
    if (justLoggedOut) {
      if (!isConnected) {
        openSystemMessage({
          text: "You are now logged out",
          kind: "information",
        })
      } else {
        openSystemMessage({
          text: "Logout unsuccessful",
          kind: "error",
        })
      }

      resetQueryParams()
    }
  }, [isLoading, isConnected, openSystemMessage])

  let title: string

  if (isLoading) title = "Loading..."
  else if (isConnected) {
    title = "Logout"
  } else {
    title = "Log In with NEAR"
  }

  return (
    <Button
      title={title}
      onClick={
        isConnected
          ? async () => {
              wallet?.disconnect()
              window.history.replaceState(null, null, "?logout")
              window.location.reload()
            }
          : async () => {
              window.history.replaceState(null, null, "?login")
              await wallet?.connect({ requestSignIn: true })
            }
      }
      kind={isConnected ? "secondary" : "primary"}
      disabled={isLoading}
      showNearLogo
    />
  )
}
